export default "skymp5-front/8039eae8736d20a186863e602db9e958.jpg";